/**
 * Auth API
 */
import apiClient from './index'
import type { ApiResponse, AuthUser, RegisterData } from '@/types'

export interface BootstrapAdminResponse {
  success: boolean
  message: string
  user_id: string
  new_role: string
}

export const authApi = {
  /**
   * Get current authenticated user
   */
  async getMe(): Promise<AuthUser> {
    const response = await apiClient.get<ApiResponse<AuthUser>>('/auth/me')
    return response.data.data
  },

  /**
   * Register a new user
   */
  async register(data: RegisterData): Promise<AuthUser> {
    const response = await apiClient.post<ApiResponse<AuthUser>>('/auth/register', data)
    return response.data.data
  },

  /**
   * Authenticate with Microsoft
   */
  async microsoftAuth(accessToken: string): Promise<{ access_token: string; user: AuthUser }> {
    const response = await apiClient.post<ApiResponse<{ access_token: string; user: AuthUser }>>(
      '/auth/microsoft',
      { access_token: accessToken }
    )
    return response.data.data
  },

  /**
   * Bootstrap first admin user
   * Only works if there are no admins yet, OR if caller is already an admin
   */
  async bootstrapAdmin(): Promise<BootstrapAdminResponse> {
    const response = await apiClient.post<BootstrapAdminResponse>('/auth/bootstrap-admin')
    return response.data
  },
}
